document.addEventListener("DOMContentLoaded", function () {
  const toc = document.getElementById("toc");
  if (!toc) return;

  // Prefer the dedicated wrapper; fallback to common article containers if needed
  const content =
    document.querySelector(".m-article-content") ||
    document.querySelector(".article__content") ||
    document.querySelector(".article-content") ||
    document.querySelector(".sf-article__content") ||
    document.querySelector(".rte") ||
    (toc.closest(".prose") || document.querySelector(".prose"));

  if (!content) {
    toc.style.display = "none";
    return;
  }

  // ✅ H2 ONLY
  const headings = content.querySelectorAll("h2");

  if (!headings.length) {
    toc.style.display = "none";
    return;
  }

  toc.style.display = "block";
  toc.innerHTML = `<div class="m-toc__title">Table of contents</div>`;

  const ul = document.createElement("ul");

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  headings.forEach((h, index) => {
    const text = (h.textContent || "").trim();
    if (!text) return;

    if (!h.id) h.id = `toc-${index}-${slugify(text)}`;

    const li = document.createElement("li");
    li.className = "m-toc__h2";

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = text;

    li.appendChild(a);
    ul.appendChild(li);
  });

  toc.appendChild(ul);
});
